const index = () => import(/* webpackChunkName: "herb" */ './Index');
const edit = () => import(/* webpackChunkName: "herb" */ './Edit');

export default {
  routes: [
    //项目
    {
      path: '/herb/v2019/index',
      name: 'herbV2019Index',
      component: index,
      meta:{public:true}
    },
    {
      path: '/herb/v2019/edit/:dbid?',
      name: 'herbV2019edit',
      component: edit,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/herb/v2019/router.js